import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { PATIENT_STATUSES, RANKS } from '../../constants/mediscribe';

/**
 * PatientDemographics - Demographics form for Patient/Letter mode
 * Extracted from App.js for maintainability
 */
export const PatientDemographics = ({
  soldierFirstName,
  setSoldierFirstName,
  soldierLastName,
  setSoldierLastName,
  soldierDob,
  setSoldierDob,
  patientStatus,
  setPatientStatus,
  soldierRank,
  setSoldierRank,
  soldierUnit,
  setSoldierUnit,
  occupation,
  setOccupation,
  jobDuties,
  setJobDuties
}) => {
  return (
    <>
      {/* Row 1 - Name and Status */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <div>
          <Label className="text-[10px] text-muted-foreground">First Name</Label>
          <Input 
            placeholder="John" 
            value={soldierFirstName} 
            onChange={(e) => setSoldierFirstName(e.target.value)} 
            className="h-8 text-sm bg-input border-border" 
            data-testid="patient-first-name-input" 
          />
        </div>
        <div>
          <Label className="text-[10px] text-muted-foreground">Last Name</Label>
          <Input 
            placeholder="Smith" 
            value={soldierLastName} 
            onChange={(e) => setSoldierLastName(e.target.value)} 
            className="h-8 text-sm bg-input border-border" 
            data-testid="patient-last-name-input" 
          />
        </div>
        <div>
          <Label className="text-[10px] text-muted-foreground">DOB</Label>
          <Input 
            type="date" 
            value={soldierDob} 
            onChange={(e) => setSoldierDob(e.target.value)} 
            className="h-8 text-sm bg-input border-border" 
            data-testid="patient-dob-input" 
          />
        </div>
        <div>
          <Label className="text-[10px] text-muted-foreground">Status</Label>
          <Select value={patientStatus} onValueChange={(v) => setPatientStatus(v)}>
            <SelectTrigger data-testid="patient-status-select-patient" className="h-8 text-xs bg-input border-border">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              {PATIENT_STATUSES.map((status) => (
                <SelectItem key={status.value} value={status.value}>{status.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      {/* Row 2 - Military fields (no phone needed for letters) */}
      {patientStatus && ['active_duty', 'active_guard', 'dependent', 'veteran', 'retiree', 'reserve'].includes(patientStatus) && (
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-[10px] text-muted-foreground">Rank</Label>
            <Select value={soldierRank || "none"} onValueChange={(val) => setSoldierRank(val === "none" ? "" : val)}>
              <SelectTrigger className="h-8 text-xs bg-input border-border" data-testid="patient-rank-select">
                <SelectValue placeholder="N/A" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">No rank / N/A</SelectItem>
                {RANKS.map((rank) => (
                  <SelectItem key={rank} value={rank}>{rank}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[10px] text-muted-foreground">Unit</Label>
            <Input 
              placeholder="e.g., 1st BDE, 82nd ABN" 
              value={soldierUnit} 
              onChange={(e) => setSoldierUnit(e.target.value)} 
              className="h-8 text-sm bg-input border-border" 
              data-testid="patient-unit-input" 
            />
          </div>
        </div>
      )}
      
      {patientStatus === 'civilian' && (
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-[10px] text-muted-foreground">Occupation</Label>
            <Input 
              placeholder="e.g., Warehouse Associate" 
              value={occupation} 
              onChange={(e) => setOccupation(e.target.value)} 
              className="h-8 text-sm bg-input border-border" 
              data-testid="patient-occupation-input" 
            />
          </div>
          <div>
            <Label className="text-[10px] text-muted-foreground">Key Job Duties</Label>
            <Input 
              placeholder="e.g., lifting, standing" 
              value={jobDuties} 
              onChange={(e) => setJobDuties(e.target.value)} 
              className="h-8 text-sm bg-input border-border" 
              data-testid="patient-job-duties-input" 
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PatientDemographics;
